/** @jsx h */

import {
  defineComponent,
  Fragment,
  h,
  onMounted,
  onUnmounted,
  reactive,
} from "vue";
import {
  IActiveBuffer,
  IBufferRouteParams,
  IBufferType,
  IDiagnostics,
  ILoggedinSession,
  IProjectChangedEventPaylod,
} from "@gratico/kernel";
import {
  BufferRoutePattern,
  IHydraState,
  RefRoutePattern,
  ShellProps,
} from "@gratico/sdk";
import { debounce } from "@gratico/stdlib";
import { inject } from "vue";
import { useRoute, RouterView } from "vue-router";

import { KernelConnection, KernelProvider } from "@app/vue/providers/index";
import { TabsIsland, NavIsland } from "@app/vue/components/index";

//import { HeaderIsland } from "../../components/HeaderIsland";
//import { NavIsland } from "../../components/NavIsland";
//import { TabsIsland } from "../../components/TabsIsland";
//import { BuffersContext, ModalsAPIContext } from "../../providers/index";
//import { setTitle } from "../../utils";
//import { ActionsIsland } from "../ActionsIsland";
//import { OverviewBar } from "../OverviewBar";
//import { BootedLayoutInner } from "./BootedLayoutInner";
//import { BufferRoute } from "./BufferRoute";
//import { Home } from "./Home";
//import { RefRoute } from "./RefRoute";
//import { ActionBar } from "../ActionBar";

export type BootedLayoutProps = {
  connection: KernelConnection;
  session: ILoggedinSession;
};
export const BootedLayout = defineComponent({
  name: "BootedLayout",
  props: ["connection", "session"],
  setup(props) {
    const { kernel, master, viewport } = props.connection;
    //    const $buffers = inject(BuffersContext);
    //    const modalsAPI = inject(ModalsAPIContext);//

    //    const $diagnostics = reactive<IDiagnostics>({
    //      diagnostics: [],
    //    });//

    //    const $activeRef = ref<string | undefined>(undefined);
    //    const $chatExpanded = ref(false);
    //    const $activePanel = ref<string | undefined>(undefined);
    //    const $activeBuffer = ref<IActiveBuffer>({});
    //    const session = props.$session.get();//

    //    setTitle(`${session.project.name}`);//

    //    const _projectChangedHandler = async (data: IProjectChangedEventPaylod) => {
    //      const activeRoute = $activeRoute.value;
    //      if (data.projectId === activeRoute?.projectId) {
    //        $diagnostics.loading = true;
    //        const diagnostics = await master.getLSPDiagnostics(
    //          data.projectId,
    //          data.ref
    //        );
    //        $diagnostics.loading = false;
    //        $diagnostics.diagnostics = diagnostics || [];
    //      }
    //    };//

    //    const projectChangedHandler = debounce(_projectChangedHandler, 600);//

    //    onMounted(() => {
    //      kernel.pubsub.emitter.on("projectChanged", projectChangedHandler);
    //    });//

    //    onUnmounted(() => {
    //      kernel.pubsub.emitter.off("projectChanged", projectChangedHandler);
    //    });//

    //    const router = inject(RouterContext)?.get();
    //    const $activeRoute = ref<Partial<IBufferRouteParams> | undefined>(
    //      undefined
    //    );//

    //    const routeHandler = () => {
    //      const params = extractParameters(
    //        BufferRoutePattern,
    //        router.location.pathname
    //      );
    //      if (params) params.type = IBufferType.FILE;
    //      $activeRoute.value = params;
    //    };//

    //    onMounted(() => {
    //      router.addEventListener("popstate", routeHandler);
    //      routeHandler();
    //    });//

    //    onUnmounted(() => {
    //      router.removeEventListener("popstate", routeHandler);
    //    });//

    //    const $hydra = ref<IHydraState>({ keyMap: [] });

    //    const childProps: ShellProps = {
    //      ...props,
    //      kernel,
    //      master,
    //      session,
    //      $activeRef,
    //      $buffers,
    //      $activeBuffer,
    //      $activePanel,
    //      $diagnostics,
    //      $expanded: $chatExpanded,
    //      $hydra,
    //      modals: modalsAPI,
    //      showInput(cmd) {
    //        modalsAPI.closeModal();
    //        modalsAPI.showModel(
    //          <ActionBar
    //            {...childProps}
    //            command={cmd}
    //            onClose={() => modalsAPI.closeModal()}
    //          />
    //        );
    //      },
    //    };//

    //          <BootedLayoutInner {...childProps} />
    //          <NavIsland {...childProps} />
    //          <OverviewBar {...childProps} />
    //          <HeaderIsland {...childProps} />
    //          <ActionsIsland {...childProps} />
    const childProps = {
      buffers: [],
      kernel,
      master,
      refName: "master",
      session: props.session,
    };
    console.log("childProps", childProps);

    return () => {
      return (
        <KernelProvider viewport={viewport} master={master} kernel={kernel}>
          {() => (
            <Fragment>
              <RouterView />
              <TabsIsland {...childProps} />
              <NavIsland {...childProps} />
            </Fragment>
          )}
        </KernelProvider>
      );
    };
  },
});
